import { sharedEnvironment } from '@vinnova/environments';

export const environment = {
  production: sharedEnvironment.sys.production,
  name: sharedEnvironment.sys.name,
  forhandsgranskaUrl: sharedEnvironment.sys.forhandsgranskaUrl,
  etjansterCommonUrl: sharedEnvironment.sys.etjansterCommonUrl,
  cookieDomain: sharedEnvironment.sys.cookieDomain,
  forhandsgranskaApiUrl: `${sharedEnvironment.sys.forhandsgranskaApiUrl}`,
  etjansterCommonApiUrl: `${sharedEnvironment.sys.gatewayUrl}/etjanster`,
  resourceStringUrl: `${sharedEnvironment.sys.gatewayUrl}/resourcestring/forhandsgranska`,
  sprakHanteringApiUrl: `${sharedEnvironment.sys.gatewayUrl}/resourcestring`,
  oregApiUrl: `${sharedEnvironment.sys.gatewayUrl}/organisationsregistret`,
  logServiceApiUrl: `${sharedEnvironment.sys.gatewayUrl}/logger`,
  projektUrl: sharedEnvironment.sys.projektUrl,
  externalLinks: sharedEnvironment.sys.externalLinks,
  baseGatewayUrl: sharedEnvironment.sys.gatewayUrl,
  apimSubscriptionKey: sharedEnvironment.sys.apimSubscriptionKey,
  msalConfig: {
    ...sharedEnvironment.msalConfig(
      sharedEnvironment.sys.forhandsgranskaApiUrl,
      'f1866331-f135-4e55-a00c-b842c59ce346',
      '7d70ad87-bc0d-42c1-8991-f92764304052',
      sharedEnvironment.sys.forhandsgranskaUrl,
    ),
    allowRedirectInIframe: true,
  },
  effektaArendekortUrl: `${sharedEnvironment.sys.effektaUrl}/Platina/modules/customized/navigera/arende.aspx`,
  effektaUrl: sharedEnvironment.sys.effektaUrl,
};
